export const ROUTE_DASHBOARD = "/neet-j2e/dashboard";
export const ROUTE_CHAT = "/neet-j2e/chat";
export const ROUTE_QUIZ = "/neet-j2e/quiz";
export const ROUTE_LOGIN = "/";
export const ROUTE_SIGN_UP = "/neet-j2e/sign-up";
export const ROUTE_AI_GENERATE = "/neet-j2e/ai-generate";
export const ROUTE_DESCRIPTIVE = "/neet-j2e/descriptive";
export const ROUTE_AI_ANALYSIS = "/neet-j2e/analysis";
export const ROUTE_PROFILE = "/neet-j2e/profile";
// Admin App Routes (root level routes for admin app)
export const ROUTE_STUDENT_MANAGEMENT = "/neet-j2e/student-management";
export const ROUTE_SCHOOL_MANAGEMENT = "/neet-j2e/school-managament";
export const ROUTE_LEARNING_ASSETS = "/neet-j2e/learning-assets";
export const routeToMCQ = (subject) =>
  `/neet-j2e/${ROUTE_QUIZ}?subject=${subject}`;
export const ROUTE_COMPETITIVE_EXAM = "/neet-j2e/competitive-exam";
export const ROUTE_MOCK_TEST = "/neet-j2e/mock-test";
export const routeEvalutionToQuiz = (subject, chapter) =>
  `${ROUTE_QUIZ}?subject=${subject}&chapter=${chapter}`;
// export const ROUTE_PAYMENT_SUCCESS = "/neet-j2e/payment-success";
